 document.addEventListener("DOMContentLoaded", function () {
   // Dynamic Currency Price changes for actual price start
  function updatePrices() {
    const metafieldElements = document.querySelectorAll("[data-sale-actual-price]");

    metafieldElements.forEach((element) => {
      const basePrice = parseFloat(element.dataset.saleActualPrice) * 100; // Convert to cents
      const conversionRate = Shopify.currency.rate; // Conversion rate for the current currency

      if (conversionRate && basePrice) {
        const convertedPrice = basePrice * conversionRate; // Convert the price
        element.innerHTML = Shopify.scFormatMoney(convertedPrice); // Update the DOM
      } else {
        console.error("Error: Conversion rate or base price is missing.");
      }
    });
  }
   // Dynamic Currency Price changes for actual price end
   

  if (Shopify.currency && Shopify.currency.rate) {
    updatePrices(); // Update on page load
    document.addEventListener("currency:changed", updatePrices); // Update on currency change
  } else {
    console.error("Shopify currency object or rate is not available.");
  }
});